import __vue_component__ from './Day.vue.js';

//
const WEEKDAYS_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var script = {
  name: 'Weeks',
  components: {
    Day: __vue_component__
  },
  props: {
    weeks: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      weekdays: WEEKDAYS_LABELS
    };
  },

  methods: {
    onDateSelected(date) {
      this.$emit('date-selected', date);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Weeks.vue_rollup-plugin-vue=script.js